export default {
  // ========== Warning messages ==========
  noHoursAssignedPrefix: 'There are no pedagogical hours assigned to the',
  noHoursAssignedSuffix: 'so sessions are not generated automatically. Configure the hours in the',
  outOfSpecMessage: 'The sessions listed below already existed and are outside of what is specified for the subject.',

  // ========== Table headers ==========
  session: 'Session',
  whatWillStudentLearn: 'WHAT WILL THE STUDENT LEARN?',
  howWillTheyLearnIt: 'HOW WILL THEY LEARN IT?',
  howWillTheyPracticeIt: 'HOW WILL THEY PRACTICE IT?',
  sessionObservationsTitle: 'OBSERVATIONS OF THE SESSION ONCE THE CLASS HAS TAKEN PLACE',
  obs: 'OBS',
  classroomActivities: 'CLASSROOM ACTIVITIES',
  basicBibliography: 'BASIC BIBLIOGRAPHY',
  associatedEvaluation: 'ASSOCIATED (ACTIVITY/EVALUATION)',

  // ========== Teacher observations ==========
  teacherObservations: 'Teacher Observations',
  observationsOfThe: 'Observations of the',
};
